import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button, {
  ButtonLink,
} from '@womcorp/wom-miwom-ui-kit/dist/components/Button';
import {
  Container,
  PanelTitle,
  ChildrenContainer,
} from './styles/ErrorTemplateStyled';
import { GoogleTagManager } from '../../helpers';

const ErrorTemplate = ({
  title,
  children,
  onClickButton,
  buttonText,
  buttonVariant,
  variant,
  markOptions,
  onBackLinkClick,
  backText,
  secondaryButtonText,
  secondaryButtonVariant,
  secondaryButtonColor,
  onClickSecondaryButton,
  icon,
  buttonIcon,
  secondaryButtonIcon,
  className,
  buttonComponent,
  startIcon,
}) => {
  useEffect(() => {
    if (
      markOptions &&
      Object.keys(markOptions).length > 0 &&
      Object.values(markOptions).every(
        value => typeof value === 'string' && value !== ''
      )
    ) {
      GoogleTagManager.pushToDataLayer(markOptions);
    }
  }, []);
  return (
    <Container className={className}>
      {icon}
      <PanelTitle>{title}</PanelTitle>
      <ChildrenContainer>{children}</ChildrenContainer>

      {onClickButton && (
        <Button
          endIcon={buttonIcon}
          color={buttonVariant}
          onClick={onClickButton}
          variant={variant}
          startIcon={startIcon}
        >
          {buttonText}
        </Button>
      )}
      {buttonComponent && buttonComponent}

      {onBackLinkClick && (
        <ButtonLink onClick={onBackLinkClick}>{backText}</ButtonLink>
      )}
      {onClickSecondaryButton && (
        <Button
          endIcon={secondaryButtonIcon}
          color={secondaryButtonColor}
          variant={secondaryButtonVariant}
          onClick={onClickSecondaryButton}
        >
          {secondaryButtonText}
        </Button>
      )}
    </Container>
  );
};

const markPropsShape = PropTypes.shape({
  event: PropTypes.string,
  page: PropTypes.string,
  pagename: PropTypes.string,
});

ErrorTemplate.defaultProps = {
  onClickButton: undefined,
  buttonText: 'REINTENTAR',
  buttonVariant: 'bubbleGum',
  onBackLinkClick: undefined,
  backText: 'Volver al inicio',
  secondaryButtonText: '',
  secondaryButtonColor: 'corporate',
  secondaryButtonVariant: 'outlined',
  onClickSecondaryButton: null,
  secondaryButtonIcon: null,
  markOptions: {
    event: '',
    page: '',
    pagename: '',
  },
  buttonIcon: null,
  className: '',
  buttonComponent: null,
  variant: 'contained',
  startIcon: null,
};

ErrorTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClickButton: PropTypes.func,
  buttonText: PropTypes.string,
  buttonVariant: PropTypes.string,
  markOptions: markPropsShape,
  onBackLinkClick: PropTypes.func,
  backText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonColor: PropTypes.string,
  secondaryButtonVariant: PropTypes.string,
  onClickSecondaryButton: PropTypes.func,
  secondaryButtonIcon: PropTypes.node,
  icon: PropTypes.node.isRequired,
  buttonIcon: PropTypes.node,
  className: PropTypes.string,
  buttonComponent: PropTypes.node,
  variant: PropTypes.string,
  startIcon: PropTypes.node,
};

export default ErrorTemplate;
